// AI search A/B test disabled temporarily for the revealed prices A/B test
export function useSemanticSearchAbTest() {
    return {
        isSemanticSearchEnabled: false
    };
}
// AI search A/B test disabled temporarily for the revealed prices A/B test
export function useSemanticSearchAbTest() {
    return {
        isSemanticSearchEnabled: false
    };
}
